import {useContext, useEffect, useMemo, useState } from 'react';
import Grid from '@mui/material/Grid2';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { APIContext } from '../../../Contexts/APIContext';
import { SessionContext } from '../../../Contexts/SessionContext';
import { useTripRateContext } from '../../TripRateContext';
import { getFilteredSurveys } from '../../../TripRateNew/TriprateFilters';

export default function GFANotInUse() {
    const [gfaStats, setGfaStats] = useState<boolean | null>(null);
    const { get } = useContext(APIContext);
    const { sessionState } = useContext(SessionContext);
    const { surveys } = useTripRateContext();

    const filteredSurveys = useMemo(() => {
        return getFilteredSurveys(
            surveys
        );
    }, [surveys, sessionState]);

    useEffect(() => {
        get("TripRateFilter", `GetGFAData?landuse=${sessionState.tripRateMain}&subuse=${sessionState.tripRateSub}`,
            (data) => {
                setGfaStats(data);
            });
    }, [sessionState.tripRateMain, sessionState.tripRateSub]);

    return (
        gfaStats === null ? <></> :
            <Grid container component={Paper} size={12}>
                <Grid size={12}>
                    <Typography>Include "GFA not in use" in GFA trip rate calculations: {gfaStats ? 'Yes' : 'No'}</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography>Number of surveys with a known "GFA not in use" figure:{filteredSurveys.filter(f=>f.gfaNotInUse != null).length}</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography>Number of surveys without this information available:{filteredSurveys.filter(f => f.gfaNotInUse == null).length}</Typography>
                </Grid>
                <Grid size={12}>
                    <Typography>In 2006, a "GFA not in use" data field was introduced. By default, total GFA is used for GFA trip rate calculations. You can now deduct "GFA not in use" from total GFA figures (where this data is available) in trip rate calculations, through a new option available via the Main Menu of TRICS. To activate this feature, click "Settings" in the user menu above, then uncheck the box labelled "Include GFA not in use in GFA trip rate calculations" and click "Save".</Typography>
                </Grid>
            </Grid>
    );
}
